import { Component, OnInit, Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-nfo-vedio-pop-up',
  templateUrl: './nfo-vedio-pop-up.component.html',
  styleUrls: ['./nfo-vedio-pop-up.component.scss']
})
export class NfoVedioPopUpComponent implements OnInit {
  @Input() public videoLink;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close();
  }
  
}
